import { FaFileContract, FaHandshake, FaShieldAlt, FaMoneyBillWave, FaLightbulb } from 'react-icons/fa';

export default function TermsOfService() {
  return (
    <div className="min-h-screen ">
      {/* Header */}
      <header className=" ">
        <div className="container mx-auto px-6 py-8">
          <div className="flex items-center justify-between">
            <div className="text-3xl font-bold text-gray-800">
              <span className="text-[#FD5F20]">ATO</span> Creative
            </div>
            <div className="text-sm text-gray-500">Effective: {new Date().toLocaleDateString()}</div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-[#FD5F20] text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex justify-center mb-6">
            <FaFileContract className="text-5xl" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-xl max-w-3xl mx-auto opacity-90">
            Clear guidelines for our working relationship to ensure success for your business
          </p>
        </div>
      </section>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaHandshake className="text-[#FD5F20] mr-3" />
              Welcome to ATO Creative
            </h2>
            <p className="text-gray-600 mb-4">
              These Terms of Service ("Terms") govern your access to and use of ATO Creative Digital Marketing Agency's services. By engaging our services, you agree to these Terms.
            </p>
          </section>

          {/* Services Section */}
          <section className="mb-16  p-8 rounded-xl ">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaLightbulb className="text-[#FD5F20] mr-3" />
              Our Services
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Service Scope</h3>
                  <p className="text-gray-600">
                    We provide digital marketing services as outlined in individual proposals or statements of work. Specific deliverables, timelines, and fees will be detailed in your service agreement.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Client Responsibilities</h3>
                  <p className="text-gray-600">
                    You agree to provide timely feedback, necessary materials, and accurate information required for us to perform our services effectively.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Payments */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaMoneyBillWave className="text-[#FD5F20] mr-3" />
              Payments & Fees
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg border-l-4 border-[#FD5F20]">
                <h3 className="font-semibold text-lg text-gray-800 mb-3">Payment Terms</h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• 50% deposit required to begin work</li>
                  <li>• Balance due upon project completion</li>
                  <li>• Net 15 terms for ongoing services</li>
                  <li>• Late payments incur 1.5% monthly interest</li>
                </ul>
              </div>
              <div className="bg-[#FD5F20] bg-opacity-5 p-6 rounded-lg border-l-4 border-[#FD5F20]">
                <h3 className="font-semibold text-lg text-gray-800 mb-3">Refund Policy</h3>
                <p className="text-gray-600">
                  Deposits are non-refundable. If you cancel services after work has begun, you will be billed for completed work at our standard hourly rate.
                </p>
              </div>
            </div>
          </section>

          {/* Intellectual Property */}
          <section className="mb-16  p-8 rounded-xl ">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaLightbulb className="text-[#FD5F20] mr-3" />
              Intellectual Property
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">1</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Client Materials</h3>
                  <p className="text-gray-600">
                    You retain ownership of all materials you provide to us. By providing these materials, you grant us the rights necessary to perform the services.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">2</span>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-gray-800 mb-2">Our Deliverables</h3>
                  <p className="text-gray-600">
                    Upon full payment, final creative work becomes your property. We retain the right to display work in our portfolio and case studies unless otherwise agreed.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Limitation of Liability */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FaShieldAlt className="text-[#FD5F20] mr-3" />
              Liability & Guarantees
            </h2>
            <div className=" p-8 rounded-xl ">
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="font-semibold text-lg text-[#FD5F20] mb-3">Performance</h3>
                  <p className="text-gray-600">
                    While we strive for excellence, we cannot guarantee specific marketing results as they depend on many external factors beyond our control.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-lg text-[#FD5F20] mb-3">Limitation</h3>
                  <p className="text-gray-600">
                    Our liability is limited to the amount paid for services. We're not liable for indirect, incidental, or consequential damages.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Termination */}
          <section className="mb-16  p-8 rounded-xl ">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Termination Policy</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">1</span>
                </div>
                <div>
                  <p className="text-gray-600">
                    Either party may terminate services with 30 days written notice. Outstanding balances become immediately due upon termination.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-[#FD5F20] bg-opacity-10 p-3 rounded-full mr-4">
                  <span className="text-[#FD5F20] font-bold">2</span>
                </div>
                <div>
                  <p className="text-gray-600">
                    We reserve the right to terminate services immediately for non-payment, unethical requests, or misuse of our services.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          
        </div>
      </main>

      {/* Footer */}
     
    </div>
  );
}